import { put, takeLatest } from 'redux-saga/effects';

import {
 getClientConfigurationsFailure,
 getClientConfigurationsSuccess,
} from '../clientConfiguration/clientConfigurationSlice';
import { identityLoginFailure } from '../identity/identitySlice';
import { sendIVAZFailure, sendIVAZSuccess } from '../ivaz/ivazSlice';
import {
 reportsGenerateFailure,
 reportsGenerateSuccess,
} from '../reports/reportsSlice';
import {
 approveResultFailure,
 approveResultSuccess,
 createItemFailure,
 createItemSuccess,
 deleteItemFailure,
 deleteItemSuccess,
 getTableFailure,
 updateItemFailure,
 updateItemSuccess,
 //  createResultFailure,
 //  createResultSuccess,
 //  deleteResultFailure,
 //  deleteResultSuccess,
 //  getResultsFailure,
 //  updateResultFailure,
 //  updateResultSuccess,
} from '../results/resultsSlice';
import { displayToast, ToastMessageProps } from './toastSlice';

function* toastSaga(data: { payload: ToastMessageProps; type: string }) {
 //  console.log(data);
 yield put(
  displayToast({
   id: data.payload.id,
   type: data.payload.type,
   message: data.payload.message,
  }),
 );
}

export function* watchToastSaga() {
 yield takeLatest(
  [
   // results
   //    getResultsSuccess.type,
   //    getResultsStructureSuccess.type,
   getTableFailure.type,
   createItemSuccess.type,
   createItemFailure.type,
   updateItemSuccess.type,
   updateItemFailure.type,
   deleteItemSuccess.type,
   deleteItemFailure.type,
   approveResultSuccess.type,
   approveResultFailure.type,
   identityLoginFailure.type,
   // filesStorage
   //    getFileStoragePicturesFailure.type,
   //    uploadFileStoragePicturesFailure.type,
   //    deleteFileStoragePictureFailure.type,
   //    deleteFileStoragePictureSuccess.type,
   //    getFileStorageDocumentsFailure.type,
   //    uploadFileStorageDocumentsSuccess.type,
   //    uploadFileStorageDocumentsFailure.type,
   //    patchFileStorageDocumentSuccess.type,
   //    patchFileStorageDocumentFailure.type,
   // clientConfiguration
   getClientConfigurationsSuccess.type,
   getClientConfigurationsFailure.type,
   // reports
   reportsGenerateSuccess?.type,
   reportsGenerateFailure?.type,
   // ivaz
   sendIVAZSuccess.type,
   sendIVAZFailure.type,
  ],
  toastSaga,
 );
}
